import { storeCreator } from '@/utils/store/store.utils';

interface State {
  isEditMode: boolean;
  setIsEditMode: (isEditMode: boolean) => void;
}

export const useEditModeStore = storeCreator<State>((set) => ({
  isEditMode: false,
  setIsEditMode: (isEditMode) => set({ isEditMode }),
}));